"use client";
import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { AuthProvider } from "react-oidc-context";
import * as oidcClientTs from "oidc-client-ts";

const AuthWrapper = ({ children }) => {
  const [isClient, setIsClient] = useState(false);
  const [getOidcConfig, setOidcConfig] = useState({});
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          oidc {
            clientid
            authority
          }
        }
      }
    }
  `);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    setOidcConfig({
      authority: data.site.siteMetadata.oidc.authority,
      client_id: data.site.siteMetadata.oidc.clientid,
      redirect_uri: `${window.location.origin}/callback`,
      response_type: "code",
      scope: "openid profile email",
      userStore: new oidcClientTs.WebStorageStateStore({
        store: window.localStorage,
      }),
      automaticSilentRenew: true,
      onSigninCallback: (_user) => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      },
    });
  }, [
    data.site.siteMetadata.oidc.authority,
    data.site.siteMetadata.oidc.clientid,
  ]);

  if (!isClient) {
    return <>{children}</>;
  }

  const currentOrigin = window.location.origin;

  return <AuthProvider {...getOidcConfig}>{children}</AuthProvider>;
};

export default AuthWrapper;
